// src/pages/pricingUnits/PricingUnits.jsx

import React from "react";
import WrapperSection from "../../components/global/WrapperSection";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import PricingUnitsTable from "../../components/pricingUnits/PricingUnitsTable";

const PricingUnits = () => {
    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            {/* data table PricingUnits */}
            <PricingUnitsTable />
        </WrapperSection>
    );
};

export default PricingUnits;
